/* BIOTRENDDY · Interacciones propias (prefijo bt-). Vanilla JS, sin librerías. */
(function () {
  'use strict';
  if (window.__btInit) return;
  window.__btInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (window.Shopify && window.Shopify.designMode) document.documentElement.classList.add('bt-editor');

  /* ---------- Reveals al hacer scroll ---------- */
  var io = null;
  function observar(root) {
    var els = (root || document).querySelectorAll('.bt-reveal:not(.bt-visible), .bt-pasos:not(.bt-visible)');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('bt-visible'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('bt-visible'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Mapa del cuerpo ---------- */
  function initMapa(root) {
    (root || document).querySelectorAll('[data-bt-mapa]').forEach(function (mapa) {
      if (mapa.dataset.btInit) return;
      mapa.dataset.btInit = '1';
      var botones = mapa.querySelectorAll('[data-bt-zona]');
      var cards = mapa.querySelectorAll('[data-bt-card]');
      function activar(id) {
        botones.forEach(function (b) {
          var on = b.getAttribute('data-bt-zona') === id;
          b.classList.toggle('is-activa', on);
          if (b.hasAttribute('aria-pressed')) b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        cards.forEach(function (c) { c.classList.toggle('is-activa', c.getAttribute('data-bt-card') === id); });
      }
      botones.forEach(function (b) {
        b.addEventListener('click', function () { activar(b.getAttribute('data-bt-zona')); });
      });
      if (botones.length) activar(botones[0].getAttribute('data-bt-zona'));
    });
  }

  /* ---------- Frase que se ilumina palabra a palabra ---------- */
  var frases = [];
  function initFrase(root) {
    (root || document).querySelectorAll('[data-bt-frase]').forEach(function (el) {
      if (el.dataset.btInit) return;
      el.dataset.btInit = '1';
      if (reduce) return;
      el.setAttribute('data-bt-activa', '');
      frases.push({ el: el, words: el.querySelectorAll('.bt-frase__w') });
    });
    pintarFrases();
  }
  function pintarFrases() {
    var vh = window.innerHeight;
    frases.forEach(function (f) {
      if (!document.body.contains(f.el)) return;
      var r = f.el.getBoundingClientRect();
      var p = (vh * 0.85 - r.top) / (r.height + vh * 0.35);
      p = Math.max(0, Math.min(1, p));
      var n = Math.round(p * f.words.length);
      f.words.forEach(function (w, i) { w.classList.toggle('is-on', i < n); });
    });
  }
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { pintarFrases(); pintarSticky(); ticking = false; });
  }, { passive: true });

  /* ---------- Chat simulado ---------- */
  function initChat(root) {
    (root || document).querySelectorAll('[data-bt-chat]').forEach(function (chat) {
      if (chat.dataset.btInit) return;
      chat.dataset.btInit = '1';
      if (reduce || !('IntersectionObserver' in window)) return;
      var msgs = chat.querySelectorAll('.bt-msg');
      var typing = chat.querySelector('.bt-typing');
      var ritmo = parseInt(chat.getAttribute('data-bt-ritmo'), 10) || 1100;
      chat.setAttribute('data-bt-anim', '');
      var ob = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        ob.disconnect();
        var i = 0;
        (function siguiente() {
          if (i >= msgs.length) { if (typing) typing.classList.remove('is-on'); return; }
          var m = msgs[i];
          var esTienda = m.classList.contains('bt-msg--tienda');
          if (esTienda && typing) {
            m.parentNode.insertBefore(typing, m);
            typing.classList.add('is-on');
          }
          setTimeout(function () {
            if (typing) typing.classList.remove('is-on');
            m.classList.add('is-on');
            i++;
            setTimeout(siguiente, ritmo * 0.55);
          }, esTienda ? ritmo : ritmo * 0.45);
        })();
      }, { threshold: 0.35 });
      ob.observe(chat);
    });
  }

  /* ---------- Galería de producto ---------- */
  function initGaleria(root) {
    (root || document).querySelectorAll('[data-bt-galeria]').forEach(function (g) {
      if (g.dataset.btInit) return;
      g.dataset.btInit = '1';
      var imgs = g.querySelectorAll('.bt-gal__main img');
      var thumbs = g.querySelectorAll('.bt-gal__thumb');
      var actual = 0;
      function ir(n) {
        if (!imgs.length) return;
        actual = (n + imgs.length) % imgs.length;
        imgs.forEach(function (im, i) { im.classList.toggle('is-activa', i === actual); });
        thumbs.forEach(function (t, i) {
          t.classList.toggle('is-activa', i === actual);
          t.setAttribute('aria-current', i === actual ? 'true' : 'false');
        });
        var imgAct = imgs[actual];
        if (imgAct && imgAct.dataset.src) { imgAct.src = imgAct.dataset.src; imgAct.removeAttribute('data-src'); }
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { ir(i); }); });
      var prev = g.querySelector('.bt-gal__flecha--prev');
      var next = g.querySelector('.bt-gal__flecha--next');
      if (prev) prev.addEventListener('click', function () { ir(actual - 1); });
      if (next) next.addEventListener('click', function () { ir(actual + 1); });
      var main = g.querySelector('.bt-gal__main');
      var x0 = null;
      if (main) {
        main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) ir(actual + (dx < 0 ? 1 : -1));
          x0 = null;
        });
      }
    });
  }

  /* ---------- Variantes (solo si el producto tiene varias) ---------- */
  function initVariantes(root) {
    (root || document).querySelectorAll('[data-bt-variantes]').forEach(function (sel) {
      if (sel.dataset.btInit) return;
      sel.dataset.btInit = '1';
      var sec = sel.closest('[data-bt-pdp]');
      if (!sec) return;
      var dataEl = sec.querySelector('[data-bt-variantes-json]');
      var variantes = [];
      try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var formato = sec.getAttribute('data-bt-moneda') || '${{amount_no_decimals_with_comma_separator}}';
      function dinero(c) {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') return window.Shopify.formatMoney(c, formato);
        return '$' + Math.round(c / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      }
      sel.addEventListener('change', function () {
        var v = variantes.find(function (x) { return String(x.id) === sel.value; });
        if (!v) return;
        sec.querySelectorAll('input[name="id"]').forEach(function (inp) { inp.value = v.id; inp.disabled = !v.available; });
        sec.querySelectorAll('[data-bt-precio]').forEach(function (p) { p.textContent = dinero(v.price); });
        sec.querySelectorAll('[data-bt-antes]').forEach(function (p) {
          p.textContent = v.compare_at_price > v.price ? dinero(v.compare_at_price) : '';
        });
        var btn = sec.querySelector('.product-form__submit');
        if (btn) {
          btn.disabled = !v.available;
          var span = btn.querySelector('span');
          if (span) span.textContent = v.available ? btn.getAttribute('data-bt-txt-ok') : btn.getAttribute('data-bt-txt-agotado');
        }
        if (v.featured_image && v.featured_image.src) {
          var g = sec.querySelector('[data-bt-galeria]');
          if (g) {
            var imgs = g.querySelectorAll('.bt-gal__main img');
            imgs.forEach(function (im, i) {
              if (im.getAttribute('data-media-id') === String(v.featured_media && v.featured_media.id)) {
                var t = g.querySelectorAll('.bt-gal__thumb')[i];
                if (t) t.click();
              }
            });
          }
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      });
    });
  }

  /* ---------- Barra fija de compra (móvil) ---------- */
  var stickies = [];
  function initSticky(root) {
    (root || document).querySelectorAll('[data-bt-sticky]').forEach(function (bar) {
      if (bar.dataset.btInit) return;
      bar.dataset.btInit = '1';
      var sec = bar.closest('[data-bt-pdp]');
      var ancla = sec ? sec.querySelector('[data-bt-ancla-compra]') : null;
      stickies.push({ bar: bar, ancla: ancla });
      var irBtn = bar.querySelector('[data-bt-ir-compra]');
      if (irBtn && ancla) {
        irBtn.addEventListener('click', function (e) {
          e.preventDefault();
          ancla.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        });
      }
    });
    pintarSticky();
  }
  /* Si la app de contra entrega ya pone su propio botón fijo abajo, la barra propia se oculta */
  function hayStickyExterno() {
    var bs = document.querySelectorAll('#rsi_buy_now_button');
    for (var i = 0; i < bs.length; i++) {
      if (bs[i].closest('.bt-sticky')) continue;
      if (window.getComputedStyle(bs[i]).position === 'fixed') return true;
    }
    return false;
  }
  function pintarSticky() {
    var externo = stickies.length ? hayStickyExterno() : false;
    stickies.forEach(function (s) {
      if (!s.ancla) return;
      if (externo) {
        s.bar.style.display = 'none';
        s.bar.classList.remove('is-on');
        document.body.classList.remove('bt-sticky-on');
        return;
      }
      s.bar.style.display = '';
      var r = s.ancla.getBoundingClientRect();
      var on = r.bottom < 0;
      s.bar.classList.toggle('is-on', on);
      document.body.classList.toggle('bt-sticky-on', on);
    });
  }

  function initTodo(e) {
    var root = e && e.target && e.target.querySelectorAll ? e.target : document;
    observar(root);
    initMapa(root);
    initFrase(root);
    initChat(root);
    initGaleria(root);
    initVariantes(root);
    initSticky(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initTodo(); });
  else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
  window.addEventListener('resize', function () { pintarFrases(); pintarSticky(); });
})();
